<script setup lang="ts">
import { MeiliSearch } from "meilisearch";
import { useManufacturersStore } from "~/stores/manufacturers";

// -----------------------
// composables
// -----------------------
const config = useRuntimeConfig();
const manufacturersStore = useManufacturersStore();
const route = useRoute();

// -----------------------
// middleware
// -----------------------
definePageMeta({
  middleware: [
    async function (to) {
      // For TNF we don't need the manufacturers page, return 404
      if (useRuntimeConfig().public.theme.site === "tnf") {
        throw createError({
          statusCode: 404,
        });
      }
      if (to.params.slug) {
        const manufacturer = await $fetch(`/api/meilisearch/manufacturer`, {
          params: { slug: to.params.slug },
        });
        if (!manufacturer) {
          throw createError({
            statusCode: 404,
          });
        }
      }
    },
  ],
});

// -----------------------
// reactive properties
// -----------------------
const isList = computed(() => !route.params.slug);

// -----------------------
// Fetch manufacturers (SSR Safe)
// -----------------------
const { data: manufacturers } = await useAsyncData(
  "manufacturers",
  async () => {
    if (process.server) {
      // Perform MeiliSearch fetch via an API route in SSR
      return await $fetch("/api/meilisearch/manufacturers");
    } else {
      // Client-side fetching (direct MeiliSearch call)
      const client = new MeiliSearch({
        host: config.public.meilisearchHost,
        apiKey: config.public.meilisearchKey,
      });
      const manufacturersIndex = client.index(
        config.public.meilisearchIndexManufacturers,
      );
      const { hits } = await manufacturersIndex.search("", {
        limit: 9999,
        sort: ["name:asc"],
      });
      return hits;
    }
  },
);

// -----------------------
// Sync store (reactively)
// -----------------------
watchEffect(() => {
  if (manufacturers.value) {
    manufacturersStore.manufacturers = manufacturers.value;
  }
});
</script>

<template>
  <ManufacturersList v-if="isList"></ManufacturersList>
  <ManufacturersPage v-else></ManufacturersPage>
</template>
